import { useContext, useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { cleanRequisitos } from '../../../../../appStore/denominaciones';
import { useConcurso } from '../../../../../providers/ConcursoProvider';
import { Accordion } from '../../../../Accordion/Accordion';
import { AccordionItem } from '../../../../Accordion/AccordionItem';
import { BackContext } from '../../../../Main';
import ConcursoData from '../../../Gestion/ConcursoData';
import { PuestoProps } from '../../../Gestion/TramitarConcursos/Commons/PuestosTable/PuestoRow';
import { InscripcionPopup } from '../../../Publico/Inscripcion/InscripcionPopup';
import { TablaDenominacionesPublicas } from '../ListaDenominaciones/TablaDenominacionesPublicas';
import ListadoActasPublicas from '../ListadoActasPublicas/ListadoActasPublicas';
import ComiteTablePublico from './ComiteTablePublico';

const SpacedContainer = styled(Container)`
  margin-bottom: 2rem;
`;

const Inscripcion = () => {
  const dispatch = useDispatch();
  const { setBackTo } = useContext(BackContext);
  const [requisitos, setRequisitos] = useState<any>({});

  const [showInscripcion, setShowInscripcion] = useState<PuestoProps | null>(null);
  const concurso = useConcurso();
  const { idLlamadoConcurso, requisitoLlamadoConcurso } = concurso;

  useEffect(() => {
    setBackTo('/');
  }, [setBackTo]);
  return (
    <SpacedContainer>
      <ConcursoData concurso={concurso} />
      <h2 className="d-flex justify-content-center text-info">Detalle del concurso</h2>
      <Accordion>
        {/* <AccordionItem title="Cronograma">
          <TablaCronogramaConcursoPublicado />
        </AccordionItem> */}
        <AccordionItem title="Miembros Comité">
          {/* <ComiteTable notCC /> */}
          <ComiteTablePublico />
        </AccordionItem>
        <AccordionItem title="Denominaciones cargadas">
          <TablaDenominacionesPublicas
            idLlamadoConcurso={idLlamadoConcurso}
            onInscribirme={(puesto: any) => setShowInscripcion(puesto)}
          />
        </AccordionItem>
        <AccordionItem title="Listado de Actas Públicas">
          <ListadoActasPublicas />
        </AccordionItem>
      </Accordion>
      <InscripcionPopup
        concurso={concurso}
        requisitos={requisitos}
        setRequisitos={setRequisitos}
        requisitoGeneral={requisitoLlamadoConcurso}
        onClose={() => {
          setRequisitos({});
          dispatch(cleanRequisitos());
          setShowInscripcion(null);
        }}
        open={!!showInscripcion}
        {...showInscripcion}
      />
    </SpacedContainer>
  );
};

export default Inscripcion;
